import React, { useEffect, useMemo, useState } from 'react';
import Modal from './Modal';
import { Link } from 'react-router-dom';
import { api, getListItems } from '../../services/api';
import { useSiteContent, sectionField } from '../../hooks/useSiteContent';

function GalleryOne() {
  const { content } = useSiteContent('home');
  const [cmsImages, setCmsImages] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');

  const subtitle = sectionField(content, 'gallery', 'subtitle', 'Make Your Tour More Pleasure');
  const title = sectionField(content, 'gallery', 'title', 'Recent Gallery');

  useEffect(() => {
    let cancelled = false;
    api.getGallery('home_recent')
      .then((res) => {
        if (cancelled) return;
        const items = getListItems(res)
          .map((item) => item.image)
          .filter(Boolean);
        setCmsImages(items);
      })
      .catch(() => {
        if (!cancelled) setCmsImages([]);
      })
      .finally(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => { cancelled = true; };
  }, []);

  const images = useMemo(() => {
    if (cmsImages.length) return cmsImages;
    const fromBlocks = [];
    for (let i = 1; i <= 20; i += 1) {
      const src = sectionField(content, 'gallery', `image_${i}`, '');
      if (src) fromBlocks.push(src);
    }
    return fromBlocks;
  }, [cmsImages, content]);

  if (!loaded || !images.length) {
    return null;
  }

  const openModal = (imageSrc, event) => {
    event.preventDefault();
    setModalImage(imageSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="gallery-area">
      <div className="container th-container shape-mockup-wrap">
        <div className="title-area text-center">
          <span className="sub-title">{subtitle}</span>
          <h2 className="sec-title">{title}</h2>
        </div>
        <div className="row g-2 g-md-3 twa-gallery-grid">
          {images.map((src, idx) => (
            <div className="col-6 col-md-4 col-xl-2" key={`${src}-${idx}`}>
              <div className="gallery-card">
                <div className="box-img global-img">
                  <Link to={src} className="popup-image" onClick={(e) => openModal(src, e)}>
                    <div className="icon-btn">
                      <i className="fal fa-magnifying-glass-plus" />
                    </div>
                  </Link>
                  <img
                    src={src}
                    alt={`${title} ${idx + 1}`}
                    onClick={(e) => openModal(src, e)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal isOpen={isModalOpen} closeModal={closeModal} imageSrc={modalImage} />
    </div>
  );
}

export default GalleryOne;
